export const HELP_WS_EVENTS = {
  SEND_MESSAGE: "helpChatMessage",
  STOP_MESSAGE: "helpStopMessage",
  MESSAGE_DELTA: "helpMessageDelta",
  STREAM_FINISH: "helpStreamFinish",
  STREAM_ERROR: "helpStreamError",
} as const;

export const FAQ_QUERY_KEY = "faq";

// NOTE: NSAI-5321 — stable, locale-independent ids for the FAQ entries a client
// deep-links to (mobile's inline "Learn more" links). The server owns the source
// of truth in `apps/nsai/server/src/help/constant/help.constant.ts` and stamps
// these onto the entries it serves; this copy exists only because the server
// deliberately does not depend on @frontend-shared (same pattern as the
// chart/diagram budgets). Keep the two in sync — a mismatch degrades to the
// plain FAQ list, it never breaks the screen.
export const FAQ_ITEM_IDS = {
  ADD_EMBEDDING_MODEL: "models-add-embedding-model",
} as const;

// NOTE: Query param carrying a FAQ_ITEM_IDS value into the FAQ screen.
export const FAQ_ITEM_DEEP_LINK_PARAM = "item";

export const HELP_WS_RECONNECTION_DELAY_MS = 1000;

export const HELP_WS_RECONNECTION_DELAY_MAX_MS = 5000;

export const HELP_CHAT_MAX_INPUT_LENGTH = 500;

// NOTE: Client-side timeout — if no delta arrives within this duration, treat as error
export const HELP_CHAT_STREAM_TIMEOUT_MS = 30_000;

export const HELP_CHAT_SUGGESTED_QUESTIONS = [
  "How do I create an assistant?",
  "What file types can I upload?",
  "How do permissions work?",
  "What AI models are supported?",
  "How do integrations work?",
  "How do I organize chats with folders?",
] as const;

export const HELP_CHAT_SUGGESTIONS_TAG = "[SUGGESTIONS]:";

export const HELP_CHAT_TOPICS_TAG = "[TOPICS]:";

export const HELP_CHAT_SLASH_COMMANDS = {
  TOPICS: "/topics",
  RESET: "/reset",
} as const;
